import { FindingState } from "@p0security/shared/types/assessment/finding";
import { Checkbox, CheckboxChangeEvent, Segmented } from "@p0security/ui";
import { Prefix } from "components/GraphTable/Prefix";
import React, { useCallback, useContext, useMemo } from "react";

import { FindingsContext } from "../contexts/FindingsContext";
import { UnassignedLabel, findingStateLabelFor } from "./finding/labels";

export const FindingsSelect: React.FC<object> = () => {
  const { assignment, setAssignment, state, setState } =
    useContext(FindingsContext);
  const stateOptions = useMemo(
    () =>
      FindingState.map((findingState) => ({
        label: findingStateLabelFor(findingState),
        value: findingState,
      })),
    []
  );

  const updateAssignmentQuery = useCallback(
    (event: CheckboxChangeEvent) =>
      setAssignment(event.target.checked ? "unassigned" : "all"),
    [setAssignment]
  );
  const updateStateQuery = useCallback(
    (state: number | string) => setState(String(state)),
    [setState]
  );

  return (
    <Prefix prefix="Findings" textWidth="md" className="w-auto">
      <Checkbox
        checked={assignment === "unassigned"}
        onChange={updateAssignmentQuery}
      >
        <UnassignedLabel />
      </Checkbox>
      <Segmented
        options={stateOptions}
        onChange={updateStateQuery}
        value={state}
      />
    </Prefix>
  );
};
